import n from"./fails.js";var o=n,f=function(t,a){var r=[][t];return!!r&&o(function(){r.call(null,a||function(){return 1},1)})};export{f as default};
